// extracted by mini-css-extract-plugin
export default {"wrapper":"l9gCWZ","wrapperVetsNegative":"VT8L9C","wrapperVetsPositive":"Vdjo0P"};